import { IDnsEntriesResponse } from "../../../../../../utils/fetch";

export interface DnsRecordRow {
  recordType: string;
  hostName: string;
  requiredValue: string;
}

export function formatDnsRecords(domainData: IDnsEntriesResponse | null): DnsRecordRow[] {
  if (!domainData?.dns) return [];

  return Object.entries(domainData.dns).map(([, entry]) => ({
    recordType: entry.type.toUpperCase(),
    hostName: entry.host,
    requiredValue: entry.data,
  }));
}

export function getHostNameForClipboard(fullHost: string, domain?: string | null): string {
  if (!domain || !fullHost) {
    return fullHost;
  }

  const trimmedDomain = domain.trim().replace(/^\.+|\.+$/g, "");
  if (!trimmedDomain) {
    return fullHost;
  }

  const hostLower = fullHost.toLowerCase();
  const domainLower = trimmedDomain.toLowerCase();

  if (hostLower === domainLower) {
    return "@";
  }

  const suffix = `.${domainLower}`;
  if (hostLower.endsWith(suffix)) {
    return fullHost.slice(0, fullHost.length - suffix.length);
  }

  return fullHost;
}
